<div class="row ">
  <div class="box-form col-12">
    <div id="header-empresa" class="form-row">
      <h3 class="form-title">{{ titulo }}</h3>
      <button data-testid="botao-adiciona-credor" class="btn" type="button" (click)="adicionarEmpresa.emit()">
        Adicionar Pessoa Jurídica
      </button>
    </div>
    <hr>
    <form [formGroup]="formEmpresa">
      <div formArrayName="empresas">
        <div id="formEmpresas" class="mt-5" *ngFor="let emp of empresasPJ.controls; let e = index" [formGroupName]="e">
          <div class="form-row align-items-center">
            <div class="col">
              <h2>Credor Pessoa Juridica {{ e + 1 }}</h2>
            </div>
            <div *ngIf="!emp.get('remove').value" class="col-auto">
              <button data-testid="botao-remove-credor" class="btn-trash text-end" type="button" (click)="removerEmpresa.emit(e)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="form-row mt-5">
            <div class="col-md-5">
              <label class="form-label">
                CNPJ <b class="text-danger">*</b>
              </label>
              <input data-testid="cnpj-credor" autocomplete="off" type="text" formControlName="cnpj"  mask="AA.AAA.AAA/AAAA-AA" class="form-control">
              <span class="error-form ml-2" *ngIf="emp.get('cnpj')?.invalid && (emp.get('cnpj')?.dirty || emp.get('cnpj')?.touched)">Campo obrigatório.</span>

            </div>
            <div class="col-md">
              <label class="form-label">
                Razão Social <b class="text-danger">*</b>
              </label>
              <input data-testid="razaoSocial-credor" autocomplete="off" type="text" maxlength="150" formControlName="nomeEmpresa" class="form-control">
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('required') && (emp.get('nomeEmpresa')?.dirty || emp.get('nomeEmpresa')?.touched)">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
            </div>
          </div>

          <!-- Representantes -->
          <div formArrayName="representantes">
            <div class="mt-5" *ngFor="let rep of getRepresentantes(e).controls; let i = index" [formGroupName]="i">
              <div class="form-row align-items-center">
                <div class="col">
                  <h2>Representante Legal {{ i + 1 }}</h2>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="col-md-5">
                  <label class="form-label">
                    Nome <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="nome-representante" autocomplete="off" type="text" formControlName="nome" maxlength="150" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('nome')?.hasError('required') && (rep.get('nome')?.dirty || rep.get('nome')?.touched)">Campo obrigatório.</span>
                </div>
                <div class="col-md">
                  <label class="form-label">
                    CPF <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="cpf-representante" autocomplete="off" type="text" formControlName="cpf"  mask="000.000.000-00" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('cpf')?.hasError('required') && (rep.get('cpf')?.dirty || rep.get('cpf')?.touched)">Campo obrigatório.</span>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="col-md">
                  <label class="form-label">
                    E-mail <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="email-representante" autocomplete="off-" type="text" formControlName="emailPj" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('required') && (rep.get('emailPj')?.dirty || rep.get('emailPj')?.touched)">Campo obrigatório.</span>
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                </div>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </form>
    <p class="info-text">
      <i class="fas fa-info-circle"></i>
      O Representante Legal indicado deve possuir poderes de representação para assinar o termo em nome do Credor Pessoa Jurídica, de acordo com a documentação Societária e Procuração (se houver) a ser enviada.
    </p>
    <div class="form-row mt-5 mb-3 d-flex justify-content-center">
      <div class="col-md-4 d-flex justify-content-center">
        <button data-testid="botao-voltar" (click)="voltar.emit()" type="button" class="btn">
          Voltar
        </button>
      </div>
      <div class="col-md-4 d-flex justify-content-center">
        <button data-testid="botao-efetuar-cadastro" (click)="efetuarCadastro.emit()" class="btn">
          Efetuar cadastro
        </button>
      </div>
    </div>
  </div>
</div>
